import styles from "./styles.module.scss";
import { Circles, Style } from "react-loader-spinner";
import classNames from "classnames";

interface Props {
  className?: string;
  width?: string | number;
  height?: string | number;
  color?: string;
  style?: Style;
}

const Spinner = ({ width, height, color, style }: Props) => {
  return (
    <Circles
      wrapperClass={classNames(styles.spinner, classNames)}
      width={width}
      height={height}
      color="#751423"
      wrapperStyle={style}
    />
  );
};

export default Spinner;
